import { Slider, Stack, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react'

const useStyles = makeStyles(theme => ({
    slider: {
        zIndex: 1,
        margin: "auto",
        width: "99%",
        '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
            backgroundColor: theme.palette.background.primaryAccent1,
            boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
            '&:focus, &:hover, &.Mui-active': {
                boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    // boxShadow: iOSBoxShadow,
                },
            },
            '&:before': {
                boxShadow:
                    '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
            },
        },
        '& .MuiSlider-valueLabel': {
            fontSize: 12,
            fontWeight: 'normal',
            top: -6,
            padding: "6px 16px",
            borderRadius: "12px",
            backgroundColor: theme.palette.background.primaryGrey2,
            color: theme.palette.background.primaryBlack1,
            '&::before': {
                display: 'none',
            },
            '& *': {
                background: 'transparent',
            },
        },
        '& .MuiSlider-track': {
            border: 'none',
            height: 5,
            backgroundColor: theme.palette.background.primaryAccent1,
        },
        '& .MuiSlider-rail': {
            height: 4,
            opacity: 0.5,
            boxShadow: 'inset 0px 0px 4px -2px #000',
            backgroundColor: theme.palette.background.primaryGrey3,
        }
    },
}));

const ScoreFilters = ({FiltersMap, setFilterAPICode, reset}) => {
    const [interviewScoreSliderValue, setInterviewScoreSliderValue] = useState([0, 100]);
    const classes = useStyles();

    useEffect(() => {
        setInterviewScoreSliderValue([0,100]);
    }, [reset]);

    return (
        <>
            <Slider
                value={interviewScoreSliderValue}
                min={0}
                step={1}
                max={100}
                onChange={(e, newValue) => {
                    setInterviewScoreSliderValue(newValue);
                    const dumStr = "INTERVIEW_SCORE";
                    setFilterAPICode(prev => {
                        const dum = { ...prev };
                        dum[FiltersMap?.filter_codes[dumStr]] = {
                            min_range: newValue[0],
                            max_range: newValue[1]
                        }
                        console.log(dum);
                        return dum;
                    })
                }}
                valueLabelDisplay="on"
                aria-labelledby="non-linear-slider"
                className={classes.slider}
            />
            <Stack direction="row" justifyContent="space-between" sx={{ mt: "-14px", zIndex: 1 }}>
                <Typography variant="caption">0</Typography>
                <Typography variant="caption">100</Typography>
            </Stack>
        </>
    )
}

export default ScoreFilters